import { Properties } from "../../core/internal/model/model"
import { Page } from "../../core/internal/page/Page"
import UAParser from "./UAParser"

export default class BrowserPropertyGenerator {
  static generate(global: any, page: Page): Properties {
    let win
    // Server-Side Ignore
    if (typeof global === "undefined") {
      win = {
        navigator: { userAgent: "", vendor: "", languages: [] },
        screen: {
          width: "",
          height: ""
        }
      }
    } else {
      win = global
    }

    const result = UAParser.parse(win.navigator.userAgent)

    const browser = result.browser
    let orientation = ""
    try {
      orientation = screen.orientation.type.match(/\b(landscape|portrait)\b/)?.[0] ?? ""
    } catch (e) {}

    return {
      browserName: browser.name || "",
      browserMajorVersion: browser.major || "",
      browserVersion: browser.version || "",
      orientation: orientation,
      userAgent: win.navigator.userAgent || "",
      pagePath: page.pagePath,
      pageTitle: page.pageName,
      host: page.host,
      url: page.url,
      referrer: page.referrer,
      queryParameter: page.queryParameter,
      protocol: page.protocol.replace(":", "")
    }
  }
}
